// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessInsightCard_bi__8frok {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}
.BusinessInsightCard_bi__title__18j5a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.BusinessInsightCard_bi__title_text__vLrS- {
  padding: 0;
  margin: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
}
.BusinessInsightCard_bi__title_link__-8eIy {
  color: var(--color-primary);
  text-decoration: underline;
  font-weight: 700;
}
.BusinessInsightCard_bi__content__vo9P6 {
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .BusinessInsightCard_bi__content__vo9P6 {
    grid-template-columns: repeat(2, 1fr);
  }
}
.BusinessInsightCard_bi__card__hsWCG {
  width: 100%;
  height: 10rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  padding: 0 1.5rem;
  border-radius: 1rem;
  cursor: pointer;
}
.BusinessInsightCard_bi__card__outline__MJBoY {
  border: 1px solid var(--color-grey);
  transition: all 500ms;
}
.BusinessInsightCard_bi__card__outline__MJBoY:hover {
  color: var(--color-primary-4);
  border: 1px solid var(--color-primary-4);
}
.BusinessInsightCard_bi__card__title__8QiOt {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.BusinessInsightCard_bi__card__value__T0ZAJ {
  font-weight: 700;
  line-height: 2.2rem;
}
@media only screen and (max-width: 25em) {
  .BusinessInsightCard_bi__card__value__T0ZAJ {
    font-size: var(--default-font-small);
  }
}

.BusinessInsightCard_selectCurrency__ClWZk {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.BusinessInsightCard_selectCurrency__text__af-U\\+ {
  display: flex;
}
.BusinessInsightCard_selectCurrency__icon__olcPY {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.BusinessInsightCard_selectCurrency__icon__olcPY:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.BusinessInsightCard_selectCurrency__icon_active__73iZO {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.BusinessInsightCard_selectCurrency__list__zH6NI {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.BusinessInsightCard_selectCurrency__list_active__x6vbc {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.BusinessInsightCard_selectCurrency__list__zH6NI li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.BusinessInsightCard_selectCurrency__list__zH6NI li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/BusinessInsightCard.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADD;AAGC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAGE;EACC,UAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;AADH;AAIE;EACC,2BAAA;EACA,0BAAA;EACA,gBAAA;AAFH;AAMC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAJF;AAME;EARD;IASE,qCAAA;EAHD;AACF;AAMC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAJF;AAME;EACC,mCAAA;EACA,qBAAA;AAJH;AAMG;EACC,6BAAA;EACA,wCAAA;AAJJ;AAUE;EACC,oCAAA;EACA,mBAAA;AARH;AAWE;EACC,gBAAA;EACA,mBAAA;AATH;AAWG;EAJD;IAKE,oCAAA;EARF;AACF;;AAaA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAVD;AAYC;EACC,aAAA;AAVF;AAaC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAXF;AAaE;EACC,4DAAA;EAEA,wCAAA;EACA,2BAAA;AAZH;AAeE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DAAA;EAEA,wCAAA;EACA,2BAAA;AAdH;AAmBC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAlBF;AAsBE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AApBH;AAwBE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAtBH;AAwBG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAtBJ","sourcesContent":["@import '../variables/breakpoints';\n\n.bi {\n\twidth: 100%;\n\tborder-radius: 2rem;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 3.5rem 2rem;\n\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 2rem;\n\n\t\t&_text {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\tfont-size: var(--default-font-size);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\t&_link {\n\t\t\tcolor: var(--color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\t&__content {\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\t}\n\n\t&__card {\n\t\twidth: 100%;\n\t\theight: 10rem;\n\t\tbox-sizing: border-box;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\tjustify-content: center;\n\t\tpadding: 0 1.5rem;\n\t\tborder-radius: 1rem;\n\t\tcursor: pointer;\n\n\t\t&__outline {\n\t\t\tborder: 1px solid var(--color-grey);\n\t\t\ttransition: all 500ms;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary-4);\n\t\t\t\tborder: 1px solid var(--color-primary-4);\n\t\t\t}\n\t\t}\n\n\n\n\t\t&__title {\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tline-height: 1.8rem;\n\t\t}\n\n\t\t&__value {\n\t\t\tfont-weight: 700;\n\t\t\tline-height: 2.2rem;\n\n\t\t\t@media only screen and (max-width: $bp-400) {\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg)\n\t\t}\n\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bi": `BusinessInsightCard_bi__8frok`,
	"bi__title": `BusinessInsightCard_bi__title__18j5a`,
	"bi__title_text": `BusinessInsightCard_bi__title_text__vLrS-`,
	"bi__title_link": `BusinessInsightCard_bi__title_link__-8eIy`,
	"bi__content": `BusinessInsightCard_bi__content__vo9P6`,
	"bi__card": `BusinessInsightCard_bi__card__hsWCG`,
	"bi__card__outline": `BusinessInsightCard_bi__card__outline__MJBoY`,
	"bi__card__title": `BusinessInsightCard_bi__card__title__8QiOt`,
	"bi__card__value": `BusinessInsightCard_bi__card__value__T0ZAJ`,
	"selectCurrency": `BusinessInsightCard_selectCurrency__ClWZk`,
	"selectCurrency__text": `BusinessInsightCard_selectCurrency__text__af-U+`,
	"selectCurrency__icon": `BusinessInsightCard_selectCurrency__icon__olcPY`,
	"selectCurrency__icon_active": `BusinessInsightCard_selectCurrency__icon_active__73iZO`,
	"selectCurrency__list": `BusinessInsightCard_selectCurrency__list__zH6NI`,
	"selectCurrency__list_active": `BusinessInsightCard_selectCurrency__list_active__x6vbc`
};
export default ___CSS_LOADER_EXPORT___;
